import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useAnalytics } from '../hooks/useAnalytics';

const AppCard = ({ app }) => {
  const { trackAppVisit } = useAnalytics();
  
  const handleAppClick = () => {
    trackAppVisit(app.title);
  };

  return (
    <div className="app-card">
      <div className="app-image">
        <i className={app.icon}></i>
      </div>
      <div className="app-content">
        <h3 className="app-title"><Link to={app.aboutLink} onClick={handleAppClick}>{app.title}</Link></h3>
        <p className="app-description">{app.description}</p>
        <div className="app-tags">
          {app.tags.map((tag, index) => (
            <span key={index} className="tag">{tag}</span>
          ))}
        </div>
        <div className="app-links">
          <Link to={app.aboutLink} className="app-link" onClick={handleAppClick}>
            <i className="fas fa-external-link-alt"></i> Go
          </Link>
          <Link to={app.privacyLink} className="app-link">
            <i className="fas fa-external-link-alt"></i> Privacy Policy
          </Link>
          <Link to={app.tosLink} className="app-link">
            <i className="fas fa-external-link-alt"></i> Terms of Service
          </Link>
        </div>
      </div>
    </div>
  );
};

AppCard.propTypes = {
  app: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    tags: PropTypes.arrayOf(PropTypes.string).isRequired,
    aboutLink: PropTypes.string.isRequired,
    privacyLink: PropTypes.string.isRequired
  }).isRequired
};

export default AppCard;
